import 'normalize.css/normalize'
import 'draft-js/dist/Draft.css'
import '../images/share_img_fb.png'

const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
ReactRailsUJS.mountComponents()
